import { render, staticRenderFns } from "./Imagenes.vue?vue&type=template&id=dda223f2&scoped=true&"
import script from "./Imagenes.vue?vue&type=script&lang=js&"
export * from "./Imagenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda223f2",
  null
  
)

export default component.exports